import { Router } from '@angular/router';
import { BasePage } from './../base.page';
import { Camera } from '@awesome-cordova-plugins/camera/ngx';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/services/user.service';
import { AuthService } from 'src/app/services/auth.service';
import { GeneralService } from './../../services/general.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MediaCaptureProvider } from 'src/app/services/media-capture';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { Platform, LoadingController, ToastController, ActionSheetController } from '@ionic/angular';
import { finalize } from 'rxjs/operators';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';

@Component({
  selector: 'shc-update',
  templateUrl: './update-profile.page.html',
  styleUrls: ['./update-profile.page.scss'],
})
export class UpdateProfilePage extends BasePage implements OnInit {
  form: UntypedFormGroup;
  coverImage: string;
  profileImage: string;
  coverImageUrl: string;
  avatarImageUrl: string;

  constructor(
    protected platform: Platform,
    camera: Camera,
    actionSheetCtrl: ActionSheetController,
    protected userService: UserService,
    protected authService: AuthService,
    protected translate: TranslateService,
    private errorService: ErrorHandlerService,
    protected loadingCtrl: LoadingController,
    mediaCapture: MediaCaptureProvider,
    toastController: ToastController,
    private router: Router,
    private generalService: GeneralService,
    private androidPermission: AndroidPermissions
  ) {
    super(platform, userService, authService, translate, loadingCtrl, toastController, mediaCapture, actionSheetCtrl, camera);
  }

  ngOnInit() {
    const emailPattern = '[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,63}';
    this.form = new UntypedFormGroup({
      name: new UntypedFormControl(null, [
        Validators.required,
        Validators.pattern('^[a-zA-Z ]*$')
      ]),
      username: new UntypedFormControl(null, [
        Validators.pattern('^(?=[a-zA-Z0-9._]{8,20}$)(?!.*[_.]{2})[^_.].*[^_.]$')
      ]),
      email: new UntypedFormControl(null, [
        Validators.required,
        Validators.email,
        Validators.pattern(emailPattern)
      ]),
      avatar: new UntypedFormControl(null),
      cover: new UntypedFormControl(null)
    });
    this.patchValues();
  }

  patchValues() {
    this.userService.get().subscribe(user => {
      this.coverImageUrl = user.cover?.url;
      this.avatarImageUrl = user?.avatar?.url ? user?.avatar?.url : 'https://ionicframework.com/docs/demos/api/avatar/avatar.svg';
      this.form.patchValue({
        name: user?.name,
        email: user?.email,
        username: user?.username
      });
    });
  }


  async managePicUpload(event: Event, maxImages: number, type: string) {
    event.stopPropagation();
    await this.cordovaPictureChange(maxImages, type);
    /*if (this.platform.is('android')) {

      this.androidPermission.checkPermission(this.androidPermission.PERMISSION.CAMERA).then(
        async (result) => {
          console.log('Has camera permission?' + JSON.stringify(result.hasPermission));
          if (!result.hasPermission) {
            this.androidPermission.requestPermission(this.androidPermission.PERMISSION.CAMERA)
              .then(async (permResp) => {
                console.log('req camera perm response: ', permResp);
                // alert('Has camera permission?' + JSON.stringify(permResp));
                if (permResp.hasPermission) {
                  await this.cordovaPictureChange(maxImages, type);
                } else {
                  await this.androidPermission.requestPermission(this.androidPermission.PERMISSION.CAMERA)
                }
              });
          } else {
            await this.cordovaPictureChange(maxImages, type);
          }
        },
        async (err) => await this.androidPermission.requestPermission(this.androidPermission.PERMISSION.CAMERA)
      );

    } else {
      await this.cordovaPictureChange(maxImages, type);
    }*/
  }

  async cordovaPictureChange(maxImages: number, type: string) {
    if (this.cordova) {
      if (this.selectedImages && this.selectedImages.length >= maxImages) {
        this.showToast(this.translate.instant(marker('ValidationMessage.MaxUploadLimit')));
        return;
      } else {
        const alert = await this.actionSheetCtrl.create({
          header: this.translate.instant(marker('Camera.Select')),
          backdropDismiss: true,
          cssClass: 'removeCancelButton',
          buttons: [
            {
              icon: 'close',
              text: this.translate.instant(marker('Buttons.Cancel')),
              role: 'cancel'
            },
            {
              icon: 'camera',
              text: this.translate.instant(marker('Camera.Source.Camera')),
              handler: () => {
                this.mediaCapture.getPicture(this.camera.PictureSourceType.CAMERA,
                  true, this.camera.MediaType.PICTURE).then(
                    async (result: any) => {
                      this.showLoader();
                      if (result) {
                        if (result.file.indexOf('data:image/') >= 0) {
                          if (type === 'profile') {
                            this.profileImage = result.file;
                          } else if (type === 'cover') {
                            this.coverImage = result.file;
                          }
                        } else {
                          this.showToast(this.translate.instant(marker('ValidationMessage.ValidImage')));
                        }
                      }
                      this.hideLoader();
                    },
                    error => {
                      this.hideLoader();
                      if(error) {
                        if (error === 20) {
                          this.showToast(this.translate.instant(marker('ValidationMessage.PermissionDenied')));
                          return;
                        }
                      } else {
                        this.showToast(this.translate.instant(marker('ValidationMessage.NoFileSelected')));
                      }
                    }
                  );
              }
            },
            {
              icon: 'images-outline',
              text: this.translate.instant(marker('Camera.Source.PhotoLibrary')),
              handler: () => {
                this.mediaCapture.getPicture(this.camera.PictureSourceType.PHOTOLIBRARY,
                  true, this.camera.MediaType.PICTURE).then(
                    async (result: any) => {
                      this.showLoader();
                      if (result) {
                        if (result.file.indexOf('data:image/') >= 0) {
                          if (type === 'profile') {
                            this.profileImage = result.file;
                          } else if (type === 'cover') {
                            this.coverImage = result.file;
                          }
                        } else {
                          this.showToast(this.translate.instant(marker('ValidationMessage.ImageOnly')));
                        }
                      }
                      this.hideLoader();
                    },
                    error => {
                      this.hideLoader();
                      if(error) {
                        this.showToast(this.translate.instant(marker('ValidationMessage.PermissionDenied')));
                      } else {
                        this.showToast(this.translate.instant(marker('ValidationMessage.NoFileSelected')));
                      }
                    }
                  );
              }
            }
          ]
        });
        await alert.present();
      }
    }
  }

  onImageChange(event: any, type: string) {
    const target = event.target as HTMLInputElement;
    const imageFiles = target.files;
    this.mediaCapture.readFile(imageFiles[0]).then((base64data) => {
      if (base64data.indexOf('data:image/') >= 0) {
        if (type === 'profile') {
          this.profileImage = base64data;
        } else if (type === 'cover') {
          this.coverImage = base64data;
        }
      }
    });
  }

  clearProfileImage() {
    /**
     * Set Default User Picture
     */
    this.avatarImageUrl = 'https://ionicframework.com/docs/demos/api/avatar/avatar.svg';
    this.profileImage = null;
  }

  onUpdate() {
    this.showLoader();
    this.form.patchValue({
      avatar: this.profileImage,
      cover: this.coverImage,
    });

    this.clean(this.form.value);

    this.userService.updateUser(this.form.value).pipe(
      finalize(() => this.hideLoader())
    ).subscribe(
      res => {
        // this.user = res;
        // this.user$.next(res);
        // this.userService.updatedUser.next(res);
        this.router.navigate(['/tabs/profile']);
      },
      error => {
        this.errorService.handle(error);
      }
    );
  }

  removeCover() {
    this.coverImage = null;
    this.coverImageUrl = null;
  }
}
